import React, { ReactElement } from 'react';
import { Col, Heading, Row } from 'idsk-react-components';
import { Message } from 'slovlex-idsk-react-components';
import { useSuccessMessageContext } from '../../context/SuccessMessageContext';
import './successMessages.scss';

export default (): ReactElement => {
  const { messages, clearMessage } = useSuccessMessageContext();

  return messages && (
    <>
      {messages.map(message => (
        <Row key={message}>
          <Col>
            <Message
              onClear={() => (clearMessage(message))}
              className="success-message"
              type="success"
            >
              <Heading className="success-message__heading" size="m">{message}</Heading>
            </Message>
          </Col>
        </Row>
      ))}
    </>
  );
};
